<template lang="pug">
  .row
    .col-12
      header.mb-4
        h1#tittle {{$route.name}}
    .col-12
      form(@submit.prevent="createUser")
        b-card( border-variant="primary" header-bg-variant="primary" header-text-variant="white")
          template(v-slot:header)
            h5.text-white.m-0 Datos personales
          .row.d-flex.justify-content-end
              .form-group.col-md-6
                label Nombres
                input.form-control(type="text" v-model="form.name" required="true")
              .form-group.col-md-6
                label Apellidos
                input.form-control(type="text" v-model="form.lastname" required="true")
              .form-group.col-md-6
                label Rut
                input.form-control(type="text"  placeholder= "11.111.111-1" v-model="form.rut" required="true" minlength="11" maxlength="12")
              .form-group.col-md-6
                label E-mail
                input.form-control(type="email" v-model="form.email" required="true")
              .form-group.col-md-6
                label Contraseña
                input.form-control(:type="passwordVisible ? 'text' : 'password'" v-model="form.password" required="true" minlength="6")
              .form-group.col-md-6
                label Repita contraseña
                input.form-control(type="password" v-model="form.repeatPassword" required="true" minlength="6")
              .form-group.form-check.w-100.text-right.px-4
                input.form-check-input(type="checkbox" id="view-pass" @click='togglePasswordVisibility')
                label.form-check-label(for="view-pass") Ver contraseña
              .form-group.form-check.px-4
              .form-group.form-check.px-4
                input.form-check-input(type="checkbox" id="change-pass" v-model="isPasswordChange")
                label.form-check-label(for="change-pass") Cambio contraseña primer login
        b-card.my-5( border-variant="primary" header-bg-variant="primary" header-text-variant="white")
          template(v-slot:header)
            h5.text-white.m-0 Permisos de aplicaciones
          b-card(v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'" border-variant="light")
            .row
              .form-group.col-auto.align-self-center
                h5.text.m-0 Empresas
              .form-group.col
                multiselect(
                  v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'"
                  v-model="form.company"
                  :options="options"
                  :multiple="true"
                  group-values="subsidiary"
                  group-label="name"
                  :group-select="true",
                  placeholder="Seleccione"
                  track-by="nombre"
                  :custom-label="subsidiaryLabel"
                )
            p
            p
          b-card(v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'" border-variant="light")
            h5.text Amulen Personal
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-ap" @click="selectAllAmulenPersonal" v-model="allSelected.appsAmulenPersonal")
                label.form-check-label(for="check-all-ap") {{ selectText.textAP }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="appAP in appsAmulenPersonal")
                    input.form-check-input(type="checkbox" :id="appAP.id" v-model="appIdsAmulenPersonal" @click="select" :value="appAP.id")
                    label.form-check-label(:for="appAP.id") {{appAP.name}}
                    p
          b-card(v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'" border-variant="light")
            h5.text Amulen
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-ac" @click="selectAllAmulenCore" v-model="allSelected.appsAmulenCore")
                label.form-check-label(for="check-all-ac") {{ selectText.textAC }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="appAC in appsAmulenCore")
                    input.form-check-input(type="checkbox" :id="appAC.id" v-model="appIdsAmulenCore" @click="select" :value="appAC.id")
                    label.form-check-label(:for="appAC.id") {{appAC.name}}
                    p
          b-card(v-if="clientLogin === 'Entel'" border-variant="light")
            h5.text  Visto Bueno
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-vb" @click="selectAllVistoBueno" v-model="allSelected.appsVistoBueno")
                label.form-check-label(for="check-all-vb") {{ selectText.textVB }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="appVB in appsVistoBueno")
                    input.form-check-input(type="checkbox" :id="appVB.id" v-model="appIdsVistoBueno" @click="select" :value="appVB.id")
                    label.form-check-label(:for="appVB.id") {{appVB.name}}
                    p
          b-card(v-if="['enseñas','Aulatributaria','cursos-grabados','reunion-tributaria'].includes(clientLogin)" border-variant="light")
            h5.text E-learning
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-e" @click="selectAllElearning" v-model="allSelected.appsElearning")
                label.form-check-label(for="check-all-e") {{ selectText.textE }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-if="['cursos-grabados','enseñas','Aulatributaria','reunion-tributaria'].includes(clientLogin)" v-for="appE in appsElearning")
                    input.form-check-input(type="checkbox" :id="appE.id" v-model="appIdsElearning" @click="select" :value="appE.id")
                    label.form-check-label(:for="appE.id")='#{{appE.number}} {{appE.title}}'
                    p
          b-card(v-if="clientLogin === 'Entel'" border-variant="light")
            h5.text Agenda App
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-ag" @click="selectAllAgendaApp" v-model="allSelected.appsAgendaApp")
                label.form-check-label(for="check-all-ag") {{ selectText.textAG }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="appAG in appsAgendaApp")
                    input.form-check-input(type="checkbox" :id="appAG.id" v-model="appIdsAgendaApp" @click="select" :value="appAG.id")
                    label.form-check-label(:for="appAG.id") {{appAG.name}}
                    p
          b-card(v-if="clientLogin === 'Entel'" border-variant="light")
            h5.text Perfil Agenda App
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="appP in agendaProfile")
                    input.form-check-input(type="radio" :id="appP.id" v-model="selectAgendaProfile" :value="appP.id")
                    label.form-check-label(:for="appP.id") {{appP.name}}
                    p
                label(v-if="selectAgendaProfile === 'expert'") Seleccione al técnico:
                v-select(v-if="selectAgendaProfile === 'expert'" :options="staffs" :reduce="staff => staff.id" label="nombre" v-model="expertId" placeholder="Ingrese nombre o rut")
        .col-12.d-flex.justify-content-between.mb-5
          button.btn.px-5(@click="$router.push('/')" id="buttonBack") Volver
          button.btn.px-5(type="submit" id="buttonCreate") Crear

</template>

<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'
import { appisAmulenCore, appisAmulenApi, appisElearning2 } from '../utils/axiosInstances'
import { equals, isEmpty } from 'validator'

export default {
  name: 'addUser',
  data () {
    return {
      form: {
        name: '',
        lastname: '',
        rut: '',
        email: '',
        password: '',
        repeatPassword: '',
        client: localStorage.getItem('clientId'),
        company: []
      },
      options: [],
      optionsSelected: [],
      allListCompanies: [],
      formatedListCompanies: [],
      allListSubsidiary: [],
      formatedListSubsidiary: [],
      appsAmulenPersonal: [
        { id: 'admin', name: 'Administración' },
        { id: 'upload', name: 'Añadir Archivos' },
        { id: 'edit', name: 'Editar' },
        { id: 'reports', name: 'Ver indicadores' },
        { id: 'addPersonal', name: 'Agregar Personal' },
        { id: 'viewFile', name: 'Ver Archivo' },
        { id: 'allEnterprise', name: 'Ver todas las Empresas' },
        { id: 'toReceivesEmail', name: 'Recibir notificaciones via correo' },
        { id: 'download', name: 'Descargar Archivos' },
        { id: 'validate', name: 'Validar Archivos' },
        { id: 'intenarlPersonal', name: 'Mostrar Personal Interno' }
      ],
      appsAmulenCore: [
        { id: 'adminUsers', name: 'Administrar usuarios' },
        { id: 'adminSettings', name: 'Administrar ajustes' }
      ],
      appsVistoBueno: [
        { id: 'panel', name: 'Panel' },
        { id: 'task', name: 'Tareas' },
        { id: 'provisioneds', name: 'Provisionales' },
        { id: 'rejected', name: 'Rechazar' },
        { id: 'editTask', name: 'Editar Tarea' }
      ],
      appsElearning: [],
      passwordVisible: false,
      selected: [],
      allSelected: {
        appsAmulenPersonal: false,
        appsAmulenCore: false,
        appsVistoBueno: false,
        appsElearning: false,
        appsAgendaApp: false
      },
      selectText: {
        textAP: 'Seleccionar todos',
        textAC: 'Seleccionar todos',
        textVB: 'Seleccionar todos',
        textE: 'Seleccionar todos',
        textAG: 'Seleccionar todos'
      },
      appIdsAmulenPersonal: [],
      appIdsAmulenCore: [],
      appIdsVistoBueno: [],
      appIdsElearning: [],
      appIdsAgendaApp: [],
      selectAgendaProfile: '',
      staffs: [],
      expertId: null,
      clientLogin: localStorage.getItem('clientName'),
      isPasswordChange: true
    }
  },
  methods: {
    togglePasswordVisibility () {
      this.passwordVisible = !this.passwordVisible
    },
    selectAllAmulenPersonal () {
      this.appIdsAmulenPersonal = []

      if (!this.allSelected.appsAmulenPersonal) {
        for (this.app in this.appsAmulenPersonal) {
          this.appIdsAmulenPersonal.push(this.appsAmulenPersonal[this.app].id.toString())
        }
      }
      this.selectText.textAP = this.allSelected.appsAmulenPersonal ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllAmulenCore () {
      this.appIdsAmulenCore = []

      if (!this.allSelected.appsAmulenCore) {
        for (this.app in this.appsAmulenCore) {
          this.appIdsAmulenCore.push(this.appsAmulenCore[this.app].id.toString())
        }
      }
      this.selectText.textAC = this.allSelected.appsAmulenCore ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllVistoBueno () {
      this.appIdsVistoBueno = []

      if (!this.allSelected.appsVistoBueno) {
        for (this.app in this.appsVistoBueno) {
          this.appIdsVistoBueno.push(this.appsVistoBueno[this.app].id.toString())
        }
      }
      this.selectText.textVB = this.allSelected.appsVistoBueno ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllElearning () {
      this.appIdsElearning = []

      if (!this.allSelected.appsElearning) {
        for (this.app in this.appsElearning) {
          this.appIdsElearning.push(this.appsElearning[this.app].id.toString())
        }
      }
      this.selectText.textE = this.allSelected.appsElearning ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllAgendaApp () {
      this.appIdsAgendaApp = []

      if (!this.allSelected.appsAgendaApp) {
        for (this.app in this.appsAgendaApp) {
          this.appIdsAgendaApp.push(this.appsAgendaApp[this.app].id.toString())
        }
      }
      this.selectText.textAG = this.allSelected.appsAgendaApp ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    select: function () {
      this.allSelected.appsAmulenPersonal = false
      this.allSelected.appsAmulenCore = false
      this.allSelected.appsVistoBueno = false
      this.allSelected.appsElearning = false
      this.allSelected.appsAgendaApp = false
    },
    async createUser () {
      const {
        name,
        password,
        repeatPassword,
        lastname,
        email,
        rut,
        client
      } = this.form

      this.alert = {
        name: false,
        passwordRequired: false,
        passwordMatch: false,
        lastname: false,
        email: false,
        rut: false,
        client: false
      }

      // Validaciones de campos

      if (isEmpty(name)) this.alert.name = true

      if (isEmpty(lastname)) this.alert.lastname = true

      if (isEmpty(rut)) this.alert.rut = true

      if (isEmpty(email)) this.alert.email = true

      if (!isEmpty(password) && !isEmpty(repeatPassword)) {
        if (!equals(password, repeatPassword)) {
          this.alert.passwordMatch = true
          this.alert.passwordRequired = true
        }
      }
      if (isEmpty(client)) this.alert.client = true

      if (
        !this.alert.name &&
        !this.alert.lastname &&
        !this.alert.rut &&
        !this.alert.email &&
        !this.alert.passwordRequired &&
        !this.alert.passwordMatch
      ) {
        const data = {
          name: this.form.name,
          lastname: this.form.lastname,
          email: this.form.email,
          rut: this.form.rut.toLowerCase(),
          password: this.form.password,
          client: this.form.client,
          permissions: {
            agenda: this.appIdsAgendaApp,
            'visto-bueno': this.appIdsVistoBueno,
            amulenPersonal: this.appIdsAmulenPersonal,
            amulenCore: this.appIdsAmulenCore,
            elearning: this.appIdsElearning,
            agendaProfile: this.selectAgendaProfile,
            expert: this.expertId
          },
          companies: this.form.company
        }
        if (!this.isPasswordChange) {
          const today = new Date()
          const dateDiff = new Date(today)
          // Suma dos días a la fecha de hoy
          dateDiff.setDate(today.getDate() + 2)
          data.updatedAt = dateDiff
        }
        await appisAmulenCore({
          method: 'post',
          url: '/signup',
          data: data
        })
        return this.$router.push('/')
      }
    },
    async getListCourses () {
      let response
      if (['cursos-grabados', 'Aulatributaria', 'reunion-tributaria'].includes(this.clientLogin)) {
        response = await appisElearning2.get('/info-test')
        this.appsElearning = response.data
      }
    },
    async getListCompanies () {
      this.formatedListCompanies = []
      const response = await appisAmulenApi.get('/enterprise/all')
      this.allListCompanies = response.data
      this.allListCompanies.map(async company => {
        this.formatedListCompanies.push({
          name: company.nombre,
          id: company.id
        })
      })
    },
    async getListSubsidiary () {
      this.formatedListSubsidiary = []
      try {
        const response = await appisAmulenApi.get('/subsidiary/')
        this.allListSubsidiary = response.data
        this.allListSubsidiary.map(async subsidiary => {
          this.formatedListSubsidiary.push({
            subsidiary: [
              {
                nomenclature: subsidiary.nomenclatura,
                nameSubsidiary: subsidiary.nombre,
                idSubsidiary: subsidiary.id,
                idCompanySubsidiary: subsidiary.ini_empresa_id
              }
            ]
          })
        })
      } catch (error) {
      }
    },
    setSubsidiaries () {
      const newArray = this.allListCompanies.reduce((acc, company) => {
        const subsidiaryFounds = this.allListSubsidiary.filter(
          subsidiary => company.id === subsidiary.ini_empresa_id
        )
        acc.push({
          name: company.nombre,
          subsidiary: subsidiaryFounds
        })
        return acc
      }, [])
      this.options = newArray
    },
    subsidiaryLabel ({ nombre, nomenclatura }) {
      return `${nombre} — ${nomenclatura}`
    },
    async getStaff () {
      try {
        const response = await appisAmulenApi.get('/staff')
        response.data.forEach(element => {
          this.staffs.push({
            nombre: `${element.nombre.toUpperCase()} ${element.ape_pat.toUpperCase()} ${element.ape_mat.toUpperCase()} (${element.rut})`,
            id: element.id
          })
        })
      } catch (error) {
      }
    }
  },
  created () {
    this.$emit('update:layout', DefaultLayout)
  },
  async mounted () {
    if (!['Aulatributaria', 'cursos-grabados', 'reunion-tributaria'].includes(this.clientLogin)) {
      await this.getListCompanies()
      await this.getListSubsidiary()
      await this.getStaff()
      this.setSubsidiaries()
    }
    await this.getListCourses()
  }
}

</script>

<style lang="stylus" scoped>
  #buttonCreate
    background-color: #43ADE1
    border : none;
    padding : 10px 30px
    text-align: center
    position: relative
    color: white;
    border-radius: 6px
  #buttonCreate:hover
    background-color: #2D9CD3
  #buttonBack
    background-color: #748993
    border : none;
    text-align: center
    position: relative
    color: white;
    border-radius: 6px
  #buttonBack:hover
    background-color: #A5ADB1
  #tittle
    color: #43ADE1
</style>
